import React, { useCallback, useMemo } from 'react'
import { useLocation, matchPath } from 'react-router'
import { useAppSelector } from 'hooks/reduxHooks'
import PageBanner from 'components/Luxkit/Banners/PageBanner'
import Group from 'components/utils/Group'
import Heading from 'components/Luxkit/Typography/Heading'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Expander from 'components/utils/Expander'
import TextLink from 'components/Luxkit/TextLink'
import useToggle from 'hooks/useToggle'
import config from 'constants/config'
import { CUDO_TRAVEL, DEALS_TRAVEL, SCOOPON_TRAVEL, TREATME_TRAVEL } from 'constants/brands'

const DOWNLOAD_WL_APP_LINK_MAPPING = {
  [CUDO_TRAVEL]: 'https://cudo-wl.onelink.me/C6cJ/grilldpromo',
  [DEALS_TRAVEL]: 'https://deals-wl.onelink.me/9stO/grilldpromo',
  [SCOOPON_TRAVEL]: 'https://scoopon-wl.onelink.me/RJWt/grilldpromo',
}

function WhiteLabelPromoBanner() {
  const currentRegion = useAppSelector((state) => state.geo.currentRegionCode)
  const userAgent = useAppSelector((state) => state.system.rawUserAgentString)
  const { value: isBannerVisible, off: closeBanner } = useToggle(true)
  const location = useLocation()

  const shouldEnableCampaign = useMemo(() =>
    currentRegion === 'AU' &&
    config?.WHITE_LABEL_GRILLD_PROMO_CAMPAIGN_ENABLED &&
    config.BRAND !== TREATME_TRAVEL &&
    (!userAgent.includes('mobileapp') && !userAgent.includes('whitelabel')), // for WL apps we have the modal promo so we don't need the banner
  [currentRegion, userAgent])

  const isCheckoutRoute = useMemo(() =>
    !!matchPath(location.pathname, { path: '/:regionCode/checkout', exact: false })
  , [location.pathname])

  const onDownloadApp = useCallback(() => {
    const link = DOWNLOAD_WL_APP_LINK_MAPPING[config.BRAND as keyof typeof DOWNLOAD_WL_APP_LINK_MAPPING]
    if (link) {
      window.open(link, '_blank')
    }
  }, [])

  if (!shouldEnableCampaign || isCheckoutRoute) return null

  return (
    <Expander expanded={isBannerVisible}>
      <PageBanner
        kind="promotional-primary-accent"
        align="start"
        description={
          <Group direction="vertical" gap={8}>
            <Heading variant="heading5">You've unlocked $10 off Grill'd!</Heading>
            <BodyText variant="large">
              {`Download the ${config.brandConfig.name} app & score a $10 Grill'd coupon`}
              &nbsp;
              <TextLink onClick={onDownloadApp}>Download now</TextLink>
            </BodyText>
          </Group>
        }
        onDismiss={closeBanner}
      />
    </Expander>
  )
}

export default WhiteLabelPromoBanner
